module.exports = __webpack_public_path__ + "static/media/front-view-jar-with-dirt-stacked-coins-with-plant-min.c6bea3bb.jpg";